import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateWebhookComponent } from 'root/webhooks/create-webhook/create-webhook.component';
import { TestWebhookComponent } from 'root/webhooks/test-webhook/test-webhook.component';
import { UpdateWebhookComponent } from 'root/webhooks/update-webhook/update-webhook.component';
import { WebhooksComponent } from 'root/webhooks/webhooks/webhooks.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'webhooks',
  },
  {
    path: 'webhooks',
    component: WebhooksComponent,
    data: { title: 'PAGE_TITLES.ROOT.webhooks' },
  },
  {
    path: 'webhooks/testing/:webhookId',
    component: TestWebhookComponent,
    data: { title: 'PAGE_TITLES.ROOT.webhook_test' },
  },
  {
    path: 'webhooks/create',
    component: CreateWebhookComponent,
    data: { title: 'PAGE_TITLES.ROOT.webhook_create' },
  },
  {
    path: 'webhooks/update/:webhookId',
    component: UpdateWebhookComponent,
    data: { title: 'PAGE_TITLES.ROOT.webhook_edit' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebhooksRoutingModule {

}
